import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class Prepayments extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '预付款项';
    }

    getColumns = () => {
        return [{
            title: '账龄',
            dataIndex: 'age'
        }, {
            title: '年末余额',
            children: [{
                title: '金额',
                dataIndex: 'thisyear'
            }, {
                title: '占总额比例',
                dataIndex: 'thisyearpropo'
            }]
        }, {
            title: '年初余额',
            children: [{
                title: '金额',
                dataIndex: 'lastyear'
            }, {
                title: '占总额比例',
                dataIndex: 'lastyearpropo'
            }]
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/Prepayments.jsx